module.exports = __webpack_public_path__ + "media/logos/ideo-1b92b2ea.png";